<template>
  <form @submit.prevent="handleSubmit()" class="regular-form">

    <!-- Bill template -->
    <attachments-field
      v-model="$attrs['bill-template']"
      :error="$attrs.errors.bill_template"
      @change="handleSubmit"
    />

  </form>
</template>

<script>
import attachmentsField from '@/components/forms/bill_template/fields/Attachments'

export default {
  name: 'bill-template-blank-form',
  inheritAttrs: false,
  props: {
    submitLabel: {
      type: String,
      default: 'Submit'
    }
  },
  components: {
    attachmentsField
  },
  methods: {
    handleSubmit () {
      this.$emit('submit')
    }
  }
}
</script>


// WEBPACK FOOTER //
// BillTemplateBlankForm.vue?d084af66